export default (a, b) => {
    let reA  = /[^a-zA-Z]/g;
    let reN  = /[^0-9]/g;
    let AInt = parseInt(a, 10);
    let BInt = parseInt(b, 10);

    if (isNaN(AInt) && isNaN(BInt)) {
        let aA = a.replace(reA, "");
        let bA = b.replace(reA, "");
        if (aA === bA) {
            let aN = parseInt(a.replace(reN, ""), 10);
            let bN = parseInt(b.replace(reN, ""), 10);
            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
    } else if (isNaN(AInt)) {//A is not an Int
        return 1;//to make alphanumeric sort first return -1 here
    } else if (isNaN(BInt)) {//B is not an Int
        return -1;//to make alphanumeric sort first return 1 here
    } else {
        return AInt > BInt ? 1 : -1;
    }
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/utils/sortAlphaNum.js
// module id = 20
// module chunks = 0